import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/AuthProvider';

export function RequireAuth({ staffOnly = false }: { staffOnly?: boolean }) {
  const { session, profile, loading, profileLoading, isStaff } = useAuth();
  const location = useLocation();

  if (loading || (session && profileLoading && !profile)) {
    return <div className="shell-boot" aria-busy="true" aria-label="Chargement" />;
  }

  if (!session) {
    return <Navigate to="/connexion" replace state={{ from: location.pathname }} />;
  }

  if (profile && !profile.is_active) {
    return (
      <div className="page-center">
        <h1>Compte désactivé</h1>
        <p>Contactez l’équipe ISBD pour réactiver votre accès.</p>
      </div>
    );
  }

  if (staffOnly && !isStaff) {
    return <Navigate to="/app" replace />;
  }

  return <Outlet />;
}

export function RedirectIfAuth() {
  const { session, loading, profileLoading, profile, isStaff } = useAuth();
  // Attendre le profil pour router admin vs app sans flash incorrect
  if (loading || (session && profileLoading && !profile)) {
    return <div className="shell-boot" aria-busy="true" aria-label="Chargement" />;
  }
  if (session) {
    return <Navigate to={isStaff ? '/admin' : '/app'} replace />;
  }
  return <Outlet />;
}
